import React from 'react'
import { Route, Routes } from 'react-router-dom'
import MyProfilePage from '../Pages/Profile/Dashboard'
function MyprofileRouters() {
  return (
    <div>
      <Routes>
        <Route path="/*" element={<MyProfilePage/>}/>
      </Routes>
    </div>
  )
}

export default MyprofileRouters